export class FloatHelper {
  static fixFloatPoint(value: number, decimalPlaces = 2) {
    if (!value) {
      return value;
    }
    return parseFloat((value).toFixed(decimalPlaces));
  }
}
